import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';
import EmailPlaceholder from './email-placeholder.svg';

const emailThumbnailContainerStyle1 = css`
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
  height: var(--email-thumbnail--container-inline-expr3);
  overflow: hidden;
  width: var(--email-thumbnail--container-inline-width);
`;

const emailThumbnailBorderStyle = css`
  border: solid 1px ${theme.colors.neutral20};
`;

type EmailThumbnailProps = {
  alt?: string;
  height?: number;
  onClick?: () => void;
  src?: string;
  width?: number;
};

export const EmailThumbnail = ({ alt, height, onClick, src, width, ...rest }: EmailThumbnailProps) => {
  const Container = onClick ? NakedButton : 'div';
  return (
    <Container
      onClick={onClick}
      {...rest}
      style={
        {
          '--email-thumbnail--container-inline-expr3': src && height != null ? `${height}px` : undefined,
          '--email-thumbnail--container-inline-width': width != null ? `${width}px` : undefined,
        } as React.CSSProperties
      }
      className={cx(emailThumbnailContainerStyle1, src ? emailThumbnailBorderStyle : '')}
    >
      <img src={src ? src : EmailPlaceholder} className='thumbnail-img' alt={alt} />
    </Container>
  );
};
